import React from 'react';

import cn from 'classnames';

import FlexBox from '../../FlexBox';

import css from './HorisontalLineSeparator.css';

export interface HorizontalLineSeparatorProps {
    className?: string;
    children: string;
}

const HorizontalLineSeparator: React.FC<
    React.PropsWithChildren<HorizontalLineSeparatorProps>
> = ({ className, children }) => {
    return (
        <FlexBox justify="center" className={cn(css.root, className)}>
            <span className={css.text}>{children}</span>
        </FlexBox>
    );
};

export default HorizontalLineSeparator;
